/**
 * @generated SignedSource<<895f6753a0c93627aae58b72e86cb2a1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductDetailsRowLink$data = {
  readonly label: string;
  readonly link: {
    readonly label: string | null;
    readonly url: string | null;
  };
  readonly subTitle: string | null;
  readonly " $fragmentType": "ProductDetailsRowLink";
};
export type ProductDetailsRowLink$key = {
  readonly " $data"?: ProductDetailsRowLink$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductDetailsRowLink">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductDetailsRowLink",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "subTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductInfoComponentLink",
      "kind": "LinkedField",
      "name": "link",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProductInfoComponentLinkRow",
  "abstractKey": null
};
})();

(node as any).hash = "7f9bf6e708423bd9ee5af939d199e449";

export default node;
